export const ID_DICTIONARY = {
    // --- GLOBAL LAYOUT ---
    LAYOUT: {
        SIDEBAR_TOGGLE: 'app-layout-sidebar-toggle',
        SIDEBAR_PANEL: 'app-layout-sidebar-panel',
        HEADER_USER_MENU: 'app-layout-user-menu',
        LOGO: 'app-layout-logo',
        NOTIFICATION_BELL: 'app-layout-notification-bell',
        NOTIFICATION_PANEL: 'app-layout-notification-panel',
        NOTIFICATION_ITEM: 'app-layout-notification-item',
        HEADER_REMINDER_BELL: 'app-layout-reminder-bell',
        SYNC_CONFLICT_BUTTON: 'app-layout-sync-conflict-button',
        SYNC_CONFLICT_CONFIRM: 'app-layout-sync-conflict-confirm',
        SYNC_REMOTE_WIPE_BUTTON: 'app-layout-sync-remote-wipe-button',
        SYNC_REMOTE_WIPE_CONFIRM: 'app-layout-sync-remote-wipe-confirm',
        APP_ROOT: 'app-root',
        BANNER_STACK: 'app-layout-banner-stack'
    },

    // --- WIZARDS ---
    WIZARDS: {
        TRIAGE_CLOSE: 'app-wizard-triage-close',
        TRIAGE_APPLY_SUGGESTION: 'app-triage-wiz-apply-sugg',
        TRIAGE_APPLY_CAT: 'app-triage-wiz-apply-cat',
        TRIAGE_SKIP: 'app-triage-wiz-skip',
        ONBOARDING_LANG: 'app-onboarding-wiz-lang',
        ONBOARDING_CURRENCY: 'app-onboarding-wiz-curr',
        ONBOARDING_TAX: 'app-onboarding-wiz-tax',
        ONBOARDING_START: 'app-onboarding-wiz-start',
        ONBOARDING_FREELANCE_YES: 'app-onboarding-wiz-freelance-yes',
        ONBOARDING_FREELANCE_NO: 'app-onboarding-wiz-freelance-no',
        ONBOARDING_NEXT: 'app-onboarding-wiz-next',
        ONBOARDING_BACK: 'app-onboarding-wiz-back',
        IMPORT_ACCOUNT: 'app-import-wiz-account',
        IMPORT_DROPZONE: 'app-import-wiz-dropzone',
        IMPORT_FILE_INPUT: 'app-import-wiz-file-input',
        IMPORT_BROWSE: 'app-import-wiz-browse',
        IMPORT_CHANGE_FILE: 'app-import-wiz-change-file',
        IMPORT_PROCESS: 'app-import-wiz-process',
        IMPORT_FINISH: 'app-import-wiz-finish',
        IMPORT_REANALYZE_HINT: 'app-import-wiz-hint',
        IMPORT_REANALYZE_BTN: 'app-import-wiz-reanalyze',
        IMPORT_PAID_CANCEL: 'app-import-wiz-paid-cancel',
        IMPORT_PAID_CONFIRM: 'app-import-wiz-paid-confirm',
        IMPORT_STEP7_ROW_DATE: 'app-import-wiz-step7-row-date',
        IMPORT_STEP7_ROW_DESC: 'app-import-wiz-step7-row-desc',
        IMPORT_STEP7_ROW_AMOUNT: 'app-import-wiz-step7-row-amount',
        IMPORT_STEP7_ROW_CAT: 'app-import-wiz-step7-row-cat',
        IMPORT_STEP7_ROW_SUBCAT: 'app-import-wiz-step7-row-subcat',
        IMPORT_STEP7_ROW_DELETE: 'app-import-wiz-step7-row-delete',
        IMPORT_STEP7_ADD_BTN: 'app-import-wiz-step7-add-btn',
        IMPORT_STEP3_CONFIRM_ALL_DUPLICATES: 'app-import-wiz-step3-confirm-all-dup',
        // F11: inline destination-account creation (step 1) + Free AI teaser (step 6)
        IMPORT_INLINE_ACCOUNT_TOGGLE: 'app-import-wiz-inline-acc-toggle',
        IMPORT_INLINE_ACCOUNT_NAME: 'app-import-wiz-inline-acc-name',
        IMPORT_INLINE_ACCOUNT_TYPE: 'app-import-wiz-inline-acc-type',
        IMPORT_INLINE_ACCOUNT_CREATE: 'app-import-wiz-inline-acc-create',
        IMPORT_INLINE_ACCOUNT_CANCEL: 'app-import-wiz-inline-acc-cancel',
        IMPORT_STEP6_UPGRADE_CTA: 'app-import-wiz-step6-upgrade-cta',
        IMPORT_STEP6_CONTINUE_FREE: 'app-import-wiz-step6-continue-free'
    },


    // --- NAVEGACIÓN (Sidebar Links) ---
    NAV: {
        SIDEBAR_PANEL: 'app-nav-sidebar-panel',
        DASHBOARD: 'app-nav-dashboard',
        TRANSACTIONS: 'app-nav-transactions',
        ANALYSIS: 'app-nav-analysis',
        PORTFOLIO: 'app-nav-portfolio',
        SETTINGS: 'app-nav-settings',
        AI_HELP: 'app-nav-ai-advisor',
        PLANS: 'app-nav-plans',
        RULES_GOALS: 'app-nav-rules-goals',
        TAX_SIMULATOR: 'app-nav-tax-simulator',
        REAL_ESTATE_SIMULATOR: 'app-nav-real-estate-simulator',
        HELP: 'app-nav-help',
        TOOLS: 'app-nav-tools',
        // F19 (D3): toggle of the collapsed "More tools" sub-group (frozen investment entries).
        TOOLS_MORE: 'app-nav-tools-more',
        PORTFOLIO_INVESTMENTS: 'app-nav-portfolio-investments',
        GESTION_AUTOMATIONS: 'app-nav-gestion-automations',
        GESTION_REVIEW_HUB: 'app-nav-gestion-review-hub',
        GESTION_GOALS: 'app-nav-gestion-goals',
        GESTION_BUDGETS: 'app-nav-gestion-budgets',
        TOOLS_FIRE: 'app-nav-tools-fire',
        TOOLS_REPORTS: 'app-nav-tools-reports',
        TOOLS_FREELANCE_TAX: 'app-nav-tools-freelance-tax',
        TOOLS_SPENDING_OPTIMIZER: 'app-nav-tools-spending-optimizer',
        TOOLS_INVOICES: 'app-nav-tools-invoices',
    },

    // --- IRPF Wizard (modo detallado) ---
    IRPF_WIZARD: {
        MODE_TOGGLE: 'app-tax-sim-mode-toggle',
        SUMMARY_VIEW: 'app-irpf-summary-view',
        SUMMARY_RESULT_BANNER: 'app-irpf-summary-result-banner',
        SUMMARY_BTN_PDF: 'app-irpf-summary-btn-pdf',
        SUMMARY_BTN_RECALCULATE: 'app-irpf-summary-btn-recalc',
        SUMMARY_BTN_BACK: 'app-irpf-summary-btn-back',
        // --- BINS (Partidas Negativas) ---
        BINS_CONTAINER: 'app-irpf-bins-container',
        BINS_ADD_BTN: 'app-irpf-bins-add-btn',
        BINS_INPUT_YEAR: 'app-irpf-bins-input-year',
        BINS_INPUT_AMOUNT: 'app-irpf-bins-input-amount',
        BINS_INPUT_KIND: 'app-irpf-bins-input-kind',
        BINS_DELETE_BTN: 'app-irpf-bins-delete-btn',
        BTN_RESCAN: 'app-irpf-wizard-btn-rescan',
        INPUT_IN_KIND: 'app-irpf-input-in-kind',
        // --- Familia numerosa (título oficial, Ley 40/2003) ---
        SELECT_LARGE_FAMILY_CATEGORY: 'app-irpf-select-large-family-category',
        INPUT_LARGE_FAMILY_MINIMUM: 'app-irpf-input-large-family-minimum'
    },

    // --- IRPF Smart Pre-Fill Modal ---
    IRPF_PREFILL: {
        MODAL: 'app-irpf-prefill-modal',
        STEP_SUMMARY: 'app-irpf-prefill-step-summary',
        BTN_NEXT: 'app-irpf-prefill-btn-next',
        BTN_APPLY: 'app-irpf-prefill-btn-apply',
        SELECT_MARITAL: 'app-irpf-prefill-select-marital',
        CHECK_JOINT: 'app-irpf-prefill-check-joint',
    },

    // --- LEYES Y SIMULADORES ---
    TAX_SIMULATOR: {
        VIEW: 'app-tax-simulator-view',
        HEADER: 'app-tax-simulator-header',
        SUMMARY_DASHBOARD: 'app-tax-simulator-summary-dashboard',
        SUMMARY_KPI: 'app-tax-simulator-summary-kpi',
        SUMMARY_GOTO_DETAILED: 'app-tax-simulator-summary-goto-detailed',
        SIMPLE_MODE_LEGACY: { // Marcado para eliminación
            INPUT_GENERAL_INCOME: 'app-tax-sim-input-general',
            INPUT_SAVINGS_INCOME: 'app-tax-sim-input-savings',
            INPUT_DEDUCTIONS: 'app-tax-sim-input-deductions',
            BTN_CALCULATE: 'app-tax-sim-btn-calculate',
            CHART_PIE: 'app-tax-sim-chart-pie',
            RESULT_CARD: 'app-tax-sim-result-card',
        },
    },

    // --- BOTTOM NAV (Móvil) ---
    BOTTOM_NAV: {
        HOME: 'app-bottom-nav-home',
        TRANSACTIONS: 'app-bottom-nav-trans',
        FINANCE_MGMT: 'app-bottom-nav-finance-mgmt',
        ANALYSIS: 'app-bottom-nav-analysis',
        TOOLS: 'app-bottom-nav-tools',
        SETTINGS: 'app-bottom-nav-settings',
    },

    // --- AI CHAT PANEL ---
    AI_CHAT: {
        PANEL_CONTAINER: 'app-ai-chat-panel',
        INPUT_MESSAGE: 'app-ai-chat-input-message',
        BTN_SEND: 'app-ai-chat-btn-send',
        BTN_CLEAR: 'app-ai-chat-btn-clear',
        BTN_CLOSE: 'app-ai-chat-btn-close',
        BTN_CREATE_RULE: 'app-ai-chat-btn-create-rule',
        BTN_USE_PAID_API: 'app-ai-chat-btn-use-paid-api'
    },

    // --- ADVISOR / AI RESEARCH VIEW ---
    ADVISOR: {
        VIEW: 'app-advisor-view',
        HEADER: 'app-advisor-header',
    },

    // --- AGENTE (yo virtual) ---
    AGENT: {
        PANEL: 'app-agent-panel',
        INPUT: 'app-agent-input',
        BTN_SEND: 'app-agent-btn-send',
        BTN_CLOSE: 'app-agent-btn-close',
        BTN_CONFIRM: 'app-agent-btn-confirm',
        BTN_CANCEL: 'app-agent-btn-cancel',
        ASK_INPUT: 'app-agent-ask-input',
        ASK_SEND: 'app-agent-ask-send'
    },

    // --- ANALYSIS ---
    ANALYSIS: {
        CONTAINER: 'app-analysis-container',
        FILTERS: 'app-analysis-filters',
        INSIGHTS: 'app-analysis-insights',
        CASHFLOW: 'app-analysis-cashflow',
        EXPLORER_CONTAINER: 'app-analysis-explorer-container',
        EXPLORER_PERIOD: 'app-analysis-explorer-period',
        EXPLORER_VISUALIZATION: 'app-analysis-explorer-visualization',
        EXPLORER_ENTORNO: 'app-analysis-explorer-entorno',
        EXPLORER_TIPO: 'app-analysis-explorer-tipo',
        EXPLORER_ROWS: 'app-analysis-explorer-rows',
        EXPLORER_CONTROLS: 'app-analysis-explorer-controls',
        EXPLORER_DIMENSION: 'app-analysis-explorer-dimension',
        EXPLORER_VALUES: 'app-analysis-explorer-values',
        EXPLORER_METRIC: 'app-analysis-explorer-metric',
        EXPLORER_CHART_TYPE: 'app-analysis-explorer-chart-type',
        EXPLORER_MODE: 'app-analysis-explorer-mode',
        EXPLORER_CHART: 'app-analysis-explorer-chart',
        FILTER_CONTEXT: 'app-analysis-filter-context',
        FILTER_PERIOD: 'app-analysis-filter-period',
        BTN_ADVANCED: 'app-analysis-btn-advanced',
        STICKY_BAR: 'app-analysis-sticky-bar',
        KPI_ROW: 'app-analysis-kpi-row',
        GAUGES: 'app-analysis-gauges',
        FLOW_EVOLUTION_GRID: 'app-analysis-flow-evolution-grid',
        PORTFOLIO_PANEL: 'app-analysis-portfolio-panel',
        BREAKDOWN: 'app-analysis-breakdown',
        FORECAST: 'app-analysis-forecast',
        SUBSCRIPTIONS: 'app-analysis-subscriptions',
        WEALTH_SECTION: 'app-analysis-wealth-section',
        EXPLORER_SAVE: 'app-analysis-explorer-save',
        SAVED_VIEWS: 'app-analysis-saved-views',
    },

    // --- DASHBOARD ---
    DASHBOARD: {
        CONTAINER: 'app-dashboard-container',
        STATS_CARDS: 'app-dash-stats',
        KPI_SPENT: 'app-dash-kpi-spent',
        KPI_SAVINGS: 'app-dash-kpi-savings',
        ATTENTION: 'app-dash-attention',
        WIDGET_BUDGETS: 'app-dash-widget-budgets',
        CHART_CASHFLOW: 'app-dash-chart-cashflow',
        WIDGET_RECENT_TX: 'app-dash-widget-recent-tx',
        WIDGET_GOALS: 'app-dash-widget-goals',
        WIDGET_PORTFOLIO: 'app-dash-widget-portfolio',
        WELCOME: 'app-dash-welcome',
        KPI_AVAILABLE: 'app-dash-kpi-available',
        KPI_NETWORTH: 'app-dash-kpi-networth',
        MOVEMENTS_CARD: 'app-dash-movements-card',
        THIS_MONTH_CARD: 'app-dash-this-month-card',
        HERO_KPI_INCOME: 'app-dash-hero-kpi-income',
        HERO_KPI_EXPENSES: 'app-dash-hero-kpi-expenses',
        HERO_KPI_SAVINGS: 'app-dash-hero-kpi-savings',
        HERO_KPI_INVESTMENT: 'app-dash-hero-kpi-investment',
        HERO_MONTH_PREV: 'app-dash-hero-month-prev',
        HERO_MONTH_NEXT: 'app-dash-hero-month-next',
        MOVEMENTS_PENDING_CHIP: 'app-dash-movements-pending-chip',
        TOP_CATEGORIES: 'app-dash-top-categories',
        TOP_CATEGORY_TOGGLE: 'app-dash-top-category-toggle',
        FREELANCE_CARD: 'app-dash-freelance-card',
        FREELANCE_CARD_CTA: 'app-dash-freelance-card-cta'
    },
    INVOICES: {
        CONTAINER: 'app-invoices-container',
        HEADER: 'app-invoices-header',
        BTN_SCAN: 'app-invoices-btn-scan',
        BTN_NEW: 'app-invoices-btn-new',
        SEARCH: 'app-invoices-search',
        FILTER_STATUS: 'app-invoices-filter-status',
        LIST: 'app-invoices-list',
        ROW: 'app-invoices-row',
        DETAIL_PANEL: 'app-invoices-detail-panel',
        FORM_MODAL: 'app-invoices-form-modal',
        FORM_ISSUER: 'app-invoices-form-issuer',
        FORM_ISSUER_NIF: 'app-invoices-form-issuer-nif',
        FORM_DATE: 'app-invoices-form-date',
        FORM_TAX_BASE: 'app-invoices-form-tax-base',
        FORM_TAX_QUOTA: 'app-invoices-form-tax-quota',
        FORM_TOTAL: 'app-invoices-form-total',
        FORM_STATUS: 'app-invoices-form-status',
        FORM_BTN_SAVE: 'app-invoices-form-btn-save',
        FORM_BTN_CANCEL: 'app-invoices-form-btn-cancel',
        BTN_EDIT: 'app-invoices-btn-edit',
        BTN_DELETE: 'app-invoices-btn-delete',
        BTN_CLOSE_DETAIL: 'app-invoices-btn-close-detail',
        // F10 — shell de 3 pestañas (list|triage|repository), filtros compartidos e importador.
        TAB_LIST: 'app-invoices-tab-list',
        TAB_TRIAGE: 'app-invoices-tab-triage',
        TAB_REPOSITORY: 'app-invoices-tab-repository',
        BTN_IMPORT: 'app-invoices-btn-import',
        IMPORT_MODAL: 'app-invoices-import-modal',
        IMPORT_DROPZONE: 'app-invoices-import-dropzone',
        IMPORT_BTN_CONFIRM: 'app-invoices-import-btn-confirm',
        FILTER_PROPERTY: 'app-invoices-filter-property',
        FILTER_YEAR: 'app-invoices-filter-year',
        FILTER_SUPPLIER: 'app-invoices-filter-supplier',
        FILTER_FORMAT: 'app-invoices-filter-format',
        FILTER_TRIAGE: 'app-invoices-filter-triage',
        FILTER_DATE_FROM: 'app-invoices-filter-date-from',
        FILTER_DATE_TO: 'app-invoices-filter-date-to',
        BTN_EXPORT_CSV: 'app-invoices-btn-export-csv',
        BTN_EXPORT_XLSX: 'app-invoices-btn-export-xlsx',
        BTN_DOWNLOAD_ZIP: 'app-invoices-btn-download-zip',
        TRIAGE_ROW: 'app-invoices-triage-row',
        TRIAGE_BTN_CONFIRM_DUP: 'app-invoices-triage-btn-confirm-dup',
        TRIAGE_BTN_LINK: 'app-invoices-triage-btn-link',
        TRIAGE_BTN_VALIDATE: 'app-invoices-triage-btn-validate',
        TRIAGE_BTN_ADD_MISSING: 'app-invoices-triage-btn-add-missing',
        REPO_TREE: 'app-invoices-repo-tree',
        REPO_FILE: 'app-invoices-repo-file',
        DETAIL_BTN_OPEN_FILE: 'app-invoices-detail-btn-open-file',
        BADGE_NO_BREAKDOWN: 'app-invoices-badge-no-breakdown',
        BADGE_RECTIFYING: 'app-invoices-badge-rectifying',
        FORM_INVOICE_NUMBER: 'app-invoices-form-invoice-number',
        FORM_PROPERTY: 'app-invoices-form-property',
        FORM_FORMAT: 'app-invoices-form-format',
        FORM_NOTE: 'app-invoices-form-note',
        // Documento adjunto opcional en el alta manual (revisión de cierre, 2026-08-27): el alta
        // manual no tenía forma de adjuntar el justificante real; badge/filtro derivados de `file`.
        FORM_ATTACHMENT_ATTACH: 'app-invoices-form-attachment-attach',
        FORM_ATTACHMENT_INPUT: 'app-invoices-form-attachment-input',
        FORM_ATTACHMENT_REMOVE: 'app-invoices-form-attachment-remove',
        BADGE_NO_FILE: 'app-invoices-badge-no-file',
        DETAIL_BTN_ATTACH_FILE: 'app-invoices-detail-btn-attach-file',
        DETAIL_ATTACHMENT_INPUT: 'app-invoices-detail-attachment-input',
        FILTER_HAS_FILE: 'app-invoices-filter-has-file',
    },
    REPORTS: {
        CONTAINER: 'app-reports-container',
        HEADER: 'app-reports-header',
        BTN_MONTHLY_PDF: 'app-reports-btn-monthly-pdf',
        BTN_MONTHLY_XLSX: 'app-reports-btn-monthly-xlsx',
        BTN_ANNUAL_PDF: 'app-reports-btn-annual-pdf',
        BTN_ANNUAL_XLSX: 'app-reports-btn-annual-xlsx',
        BTN_CATEGORY_PDF: 'app-reports-btn-category-pdf',
        BTN_TAX_PDF: 'app-reports-btn-tax-pdf',
        SELECT_YEAR: 'app-reports-select-year',
        SELECT_MONTH: 'app-reports-select-month'
    },

    // --- SETTINGS (Ajustes) ---
    // --- CAPTURA RÁPIDA (voz/foto) ---
    CAPTURE: {
        PANEL: 'app-capture-panel',
        SELECT_ACCOUNT: 'app-capture-select-account',
        INPUT_LABEL: 'app-capture-input-label',
        BTN_CREATE_TOKEN: 'app-capture-btn-create-token',
        BTN_COPY_TOKEN: 'app-capture-btn-copy-token',
        BTN_DISMISS_TOKEN: 'app-capture-btn-dismiss-token',
        BTN_REVOKE_TOKEN: 'app-capture-btn-revoke-token',
        BTN_COPY_URL: 'app-capture-btn-copy-url',
        BTN_TOGGLE_GUIDE: 'app-capture-btn-toggle-guide',
        BTN_UPGRADE: 'app-capture-btn-upgrade',
        TOKEN_LIST: 'app-capture-token-list',
        TAB: 'app-settings-tab-capture',
        // Captura rápida dentro de la app (modal de dictado/foto)
        MODAL: 'app-capture-modal',
        BTN_CLOSE: 'app-capture-btn-close',
        BTN_MODE_VOICE: 'app-capture-btn-mode-voice',
        BTN_MODE_PHOTO: 'app-capture-btn-mode-photo',
        BTN_DICTATE: 'app-capture-btn-dictate',
        BTN_PICK_PHOTO: 'app-capture-btn-pick-photo',
        BTN_SEND: 'app-capture-btn-send',
        BTN_FINISH: 'app-capture-btn-finish',
        INPUT_TEXT: 'app-capture-input-text',
        INPUT_NOTE: 'app-capture-input-note',
        INPUT_PHOTO: 'app-capture-input-photo',
        FAB_OPT: 'app-capture-fab-option',
        HEADER_BTN: 'app-capture-header-btn',
    },

    SETTINGS: {
        PANEL: 'app-settings-panel',
        PANEL_ROOT: 'app-settings-panel-root',
        CONTAINER: 'app-settings-container',
        TAB_ACCOUNT: 'app-settings-tab-account',
        TAB_CONFIG: 'app-settings-tab-config',
        TAB_DESIGN: 'app-settings-tab-design',
        TAB_ANALYTICS: 'app-settings-tab-analytics',
        ANALYTICS_PANEL: 'app-settings-analytics-panel',
        ANALYTICS_BTN_REFRESH: 'app-settings-analytics-btn-refresh',
        ANALYTICS_TABLE: 'app-settings-analytics-table',
        ANALYTICS_BREAKDOWN: 'app-settings-analytics-breakdown',
        ANALYTICS_SOURCE_TABLE: 'app-settings-analytics-source-table',
        ANALYTICS_IMPORT_FUNNEL_TABLE: 'app-settings-analytics-import-funnel-table',
        TAB_BANKS: 'app-settings-tab-banks',
        TAB_IA_API: 'app-settings-tab-ai',
        TAB_SECURITY: 'app-settings-tab-security',
        TAB_COVERAGE: 'app-settings-tab-coverage',
        COVERAGE_DONUT: 'app-settings-coverage-donut',
        COVERAGE_BAR: 'app-settings-coverage-bar',
        COVERAGE_TABLE: 'app-settings-coverage-table',
        COVERAGE_BTN_CREATE_RULE: 'app-settings-coverage-btn-create-rule',
        INPUT_DRIVE: 'app-settings-input-drive',
        INPUT_USERNAME: 'app-settings-input-username',
        INPUT_FIRST_NAME: 'app-settings-input-first-name',
        INPUT_LAST_NAME: 'app-settings-input-last-name',
        INPUT_BIRTH_DATE: 'app-settings-input-birth-date',
        INPUT_PHONE: 'app-settings-input-phone',
        INPUT_PHONE_PREFIX: 'app-settings-input-phone-prefix',
        SELECT_LANGUAGE: 'app-settings-select-language',
        SELECT_CURRENCY: 'app-settings-select-currency',
        INPUT_CUSTOM_API_KEY: 'app-settings-input-custom-api-key',
        INPUT_OLD_PASSWORD: 'app-settings-input-old-password',
        INPUT_NEW_PASSWORD: 'app-settings-input-new-password',
        INPUT_CONFIRM_PASSWORD: 'app-settings-input-confirm-password',
        INPUT_ADDRESS: 'app-settings-input-address',
        INPUT_CITY: 'app-settings-input-city',
        INPUT_ZIPCODE: 'app-settings-input-zipcode',
        INPUT_PROVINCE: 'app-settings-input-province',
        INPUT_COUNTRY: 'app-settings-input-country',
        SELECT_EMPLOYMENT: 'app-settings-select-employment',
        SELECT_TAX_REGION: 'app-settings-select-tax-region',
        INPUT_GROSS_SALARY: 'app-settings-input-gross-salary',
        INPUT_BIRTH_YEAR: 'app-settings-input-birth-year',
        INPUT_CHILDREN: 'app-settings-input-children',
        INPUT_DISABILITY: 'app-settings-input-disability',
        SELECT_BACKUP_FREQ: 'app-settings-select-backup-freq',
        INPUT_BACKUP_TIME: 'app-settings-input-backup-time',
        INPUT_MIGRATE_EMAIL: 'app-settings-input-migrate-email',
        INPUT_MIGRATE_PWD: 'app-settings-input-migrate-password',
        INPUT_MIGRATE_NEW_PWD: 'app-settings-input-migrate-new-password',
        CHECKBOX_MIGRATE_KEEP_PWD: 'app-settings-migrate-keep-password',
        CHECKBOX_THOUSANDS_SEP: 'app-settings-chk-thousands-sep',
        CHECKBOX_DECIMALS: 'app-settings-chk-decimals',
        // F14 — recordatorios (email semanal + push de calendario fiscal).
        CHECKBOX_NOTIF_WEEKLY_EMAIL: 'app-settings-chk-notif-weekly-email',
        CHECKBOX_NOTIF_PUSH: 'app-settings-chk-notif-push',
        CHECKBOX_BACKUP_ENABLED: 'app-settings-chk-backup-enabled',
        CHECKBOX_CONSENT_SERVICE: 'app-settings-chk-consent-service',
        CHECKBOX_CONSENT_TRAINING: 'app-settings-chk-consent-training',
        CHECKBOX_CONSENT_COLLABORATIVE: 'app-settings-chk-consent-collaborative',
        BTN_BACKFILL_COLLABORATIVE: 'app-settings-btn-backfill-collaborative',
        INPUT_AI_SPENDING_LIMIT: 'app-settings-input-ai-spending-limit',
        CARD_GEMINI_API: 'app-settings-card-gemini',
        // Settings Elements
        BTN_SAVE: 'app-settings-btn-save',
        BTN_ADD_ACCOUNT: 'app-settings-btn-add-account',
        BTN_DEL_ACCOUNT_PREFIX: 'app-settings-btn-del-account-',
        BTN_SWITCH_USER: 'app-settings-btn-switch-user-',
        BTN_REMOVE_USER: 'app-settings-btn-remove-user-',
        BTN_ADD_USER: 'app-settings-btn-add-user',
        BTN_UPDATE_PWD: 'app-settings-btn-update-pwd',
        BTN_MANUAL_SYNC: 'app-settings-btn-manual-sync',
        BTN_EXPORT_SHEETS: 'app-settings-btn-export-sheets',
        BTN_EXPORT_BACKUP: 'app-settings-btn-export-backup',
        BTN_MIGRATE: 'app-settings-btn-migrate',
        BTN_MIGRATE_CONFIRM: 'app-settings-btn-migrate-confirm',
        BTN_MIGRATE_CANCEL: 'app-settings-btn-migrate-cancel',
        BTN_SNAPSHOT_RESTORE_CONFIRM: 'app-settings-btn-snapshot-restore-confirm',
        BTN_SNAPSHOT_RESTORE_CANCEL: 'app-settings-btn-snapshot-restore-cancel',
        BTN_FACTORY_RESET: 'app-settings-btn-factory-reset',
        ENCRYPTION_SECTION: 'app-settings-encryption-section',
        ENCRYPTION_INPUT_PASS: 'app-settings-encryption-input-pass',
        ENCRYPTION_BTN_SETUP: 'app-settings-encryption-btn-setup',
        ENCRYPTION_INPUT_UNLOCK: 'app-settings-encryption-input-unlock',
        ENCRYPTION_BTN_UNLOCK: 'app-settings-encryption-btn-unlock',
        ENCRYPTION_BTN_CHANGE: 'app-settings-encryption-btn-change',
        ENCRYPTION_INPUT_NEW: 'app-settings-encryption-input-new',
        ENCRYPTION_RECOVERY_PANEL: 'app-settings-encryption-recovery-panel',
        ENCRYPTION_BTN_RECOVERY_CONFIRM: 'app-settings-encryption-btn-recovery-confirm',
        ENCRYPTION_INPUT_RECOVERY: 'app-settings-encryption-input-recovery',
        ENCRYPTION_BTN_RESET_RECOVERY: 'app-settings-encryption-btn-reset-recovery',
        ENCRYPTION_BTN_REGENERATE: 'app-settings-encryption-btn-regenerate',
        ENCRYPTION_UNLOCK_GATE: 'app-settings-encryption-unlock-gate',
        ENCRYPTION_SETUP_GATE: 'app-settings-encryption-setup-gate',
        ENCRYPTION_BTN_SETUP_GATE: 'app-settings-encryption-btn-setup-gate',
        ENCRYPTION_BTN_DEFER: 'app-settings-encryption-btn-defer',
        ENCRYPTION_BANNER_LOCAL_ONLY: 'app-settings-encryption-banner-local-only',
        ENCRYPTION_BANNER_CTA: 'app-settings-encryption-banner-cta',
        BTN_DELETE_ACCOUNT: 'app-settings-btn-delete-account',
        MODAL_DELETE_ACCOUNT: 'app-settings-modal-delete-account',
        INPUT_DELETE_ACCOUNT_PASSWORD: 'app-settings-input-delete-account-password',
        BTN_DELETE_ACCOUNT_CONFIRM: 'app-settings-btn-delete-account-confirm',
        LEGAL_TERMS_LINK: 'app-settings-legal-terms-link',
        INACTIVITY_MODAL: 'app-inactivity-warning-modal',
        INACTIVITY_TITLE: 'app-inactivity-title',
        INACTIVITY_STAY_BTN: 'app-inactivity-stay-btn',
        // F17: conflict rescue backup card (SettingsSecurity)
        CONFLICT_BACKUP_SECTION: 'app-settings-conflict-backup-section',
        CONFLICT_BACKUP_BTN_DOWNLOAD: 'app-settings-conflict-backup-btn-download',
        CONFLICT_BACKUP_BTN_DELETE: 'app-settings-conflict-backup-btn-delete'
    },

    // --- COMMON COMPONENTS ---
    COMMON: {
        CONNECT_DRIVE: 'app-common-connect-drive',
        BTN_EDIT: 'app-common-btn-edit',
    },
    // --- DATA MANAGEMENT (Gestión de Datos) ---
    DATA: {
        DASHBOARD: 'app-data-dashboard',
        TAB_ACCOUNTS: 'app-data-tab-accounts',
        TAB_SUMMARY: 'app-data-tab-summary',
        TAB_INVESTMENTS: 'app-data-tab-investments',

        // View Containers
        ACCOUNT_VIEW: 'app-data-account-view',
        RULE_VIEW: 'app-data-rule-view',
        VIEW_ACCOUNTS_UNIFIED: 'app-data-view-accounts',
        VIEW_INVESTMENTS: 'app-data-view-investments',
        ACCOUNT_DRAG_HANDLE: 'app-data-account-drag-handle',

        // Buttons
        BTN_ADD_NEW: 'app-data-btn-add-new',
        BTN_DELETE: 'app-data-btn-delete',
        BTN_NEW_ASSET: 'app-data-btn-new-asset',
        BTN_NEW_ASSET_EMPTY: 'app-hub-btn-new-asset-empty',
        BTN_DELETE_CANCEL: 'app-data-btn-delete-cancel',
        BTN_DELETE_CONFIRM: 'app-data-btn-delete-confirm',

        // Lists
        LIST_ACCOUNTS: 'app-data-list-accounts',

        // Cuenta Form
        FORM_NAME: 'app-data-form-name',
        FORM_TYPE: 'app-data-form-type',
        FORM_ID: 'app-data-form-id',
        FORM_BANK_SELECT: 'app-data-form-bank-select',
        FORM_BANK_MANUAL: 'app-data-form-bank-manual',
        FORM_CASH_CHECK: 'app-data-form-cash',
        FORM_OPENING_BALANCE: 'app-data-form-opening-balance',
        FORM_COLOR_SELECT: 'app-data-form-color-select',
        FORM_COLOR_OPTION: 'app-data-form-color-option-',
        FORM_BTN_SAVE: 'app-data-form-save',
        FORM_BTN_CANCEL: 'app-data-form-cancel',

        // Asset Form

        // Rule Form
        RULE_INPUT_CATEGORY: 'app-rule-input-category',
        RULE_BTN_SAVE: 'app-rule-btn-save',
        RULE_MOD_CONCEPT_TYPE: 'app-rule-mod-concept-type',
        RULE_MOD_CONCEPT_VAL: 'app-rule-mod-concept-val',
        RULE_MOD_DESC_TYPE: 'app-rule-mod-desc-type',
        RULE_MOD_DESC_VAL: 'app-rule-mod-desc-val',

        // Goal Form
        GOAL_INPUT_TITLE: 'app-goal-input-title',
        GOAL_INPUT_TARGET: 'app-goal-input-target',
        GOAL_BTN_SAVE: 'app-goal-btn-save',

        // Advanced Rule Form / AI
        RULE_BTN_CREATE_ADVANCED: 'app-data-rule-create-advanced',
        RULE_BTN_TOGGLE_CODE: 'app-data-rule-toggle-code',
        RULE_INPUT_AI_PROMPT: 'app-data-rule-input-ai-prompt',
        RULE_BTN_AI_GENERATE: 'app-data-rule-btn-ai-generate',
        RULE_BTN_APPLY_AI_CODE: 'app-data-rule-apply-ai-code',


        // Empty State Actions
        ACTION_IMPORT: 'app-empty-action-import',
        ACTION_DEMO: 'app-empty-action-demo',

    },

    // --- F1: SAMPLE DATA SEEDED IN THE USER'S OWN ACCOUNT ---
    DEMO_SEED: {
        BANNER: 'app-demo-seed-banner',
        BTN_PURGE: 'app-demo-seed-btn-purge',
    },

    // --- G12 (PLAN_ONBOARDING_TUTORIAL_2, N17): pre-login demo session (DEMO_UID) announcement ---
    DEMO_SESSION: {
        BANNER: 'app-demo-session-banner',
        BTN_EXIT: 'app-demo-session-btn-exit',
    },

    // --- F5: "PRIMEROS PASOS" ACTIVATION CHECKLIST (PLAN_ONBOARDING_TUTORIAL) ---
    ACTIVATION: {
        CARD: 'app-activation-card',
        BTN_HIDE: 'app-activation-btn-hide',
        NAV_BUTTON: 'app-activation-nav-button',
        STEP_IMPORT_DATA: 'app-activation-step-import-data',
        STEP_CATEGORIZE: 'app-activation-step-categorize',
        STEP_SET_BUDGET: 'app-activation-step-set-budget',
        STEP_FISCAL_ESTIMATE: 'app-activation-step-fiscal-estimate',
        STEP_REVIEW_RECURRING: 'app-activation-step-review-recurring',
        // G5 (PLAN_ONBOARDING_TUTORIAL_2, N9): manual-only steps (fiscal_estimate,
        // review_recurring) never both render at once — their `gate`s are mutually
        // exclusive on `isSelfEmployed` (activationChecklist.ts) — so one shared id is safe.
        BTN_MARK_DONE: 'app-activation-btn-mark-done',
    },

    // --- F6: CONTEXTUAL COACH MARKS (PLAN_ONBOARDING_TUTORIAL) ---
    COACH: {
        CARD: 'app-coach-mark-card',
        BTN_ACK: 'app-coach-mark-btn-ack',
        BTN_DISABLE: 'app-coach-mark-btn-disable',
    },

    // --- OPERATIVA (FAB) ---
    FAB: {
        CONTAINER: 'app-fab-container',
        MAIN_BUTTON: 'app-fab-main',
        OPT_MANUAL: 'app-fab-manual',
        OPT_SCAN: 'app-fab-scan',
        OPT_IMPORT: 'app-fab-import',
        OPT_TRANSACTIONS: 'app-fab-transactions',
        OPT_AI: 'app-fab-ai',
        OPT_ADVANCED_ANALYSIS: 'app-fab-advanced-analysis',
        OPT_REVIEW_RULES: 'app-fab-review-rules',
        OPT_TAX_SIMULATOR: 'app-fab-tax-simulator',
        OPT_BACK: 'app-fab-back'
    },

    // --- MANUAL TRANSACTION MODAL ---
    MANUAL_MODAL: {
        INPUT_AMOUNT: 'app-manual-input-amount',
        INPUT_DESC: 'app-manual-input-desc',
        INPUT_ACCOUNT: 'app-manual-input-account',
        INPUT_ENTORNO: 'app-manual-input-entorno',
        BTN_SAVE: 'app-manual-btn-save',
        BTN_CLOSE: 'app-manual-btn-close'
    },

    // --- EDIT TRANSACTION MODAL ---
    EDIT_MODAL: {
        INPUT_AMOUNT: 'app-edit-input-amount',
        INPUT_DESC: 'app-edit-input-desc',
        INPUT_CONCEPT: 'app-edit-input-concept',
        INPUT_DATE: 'app-edit-input-date',
        INPUT_ACCOUNT: 'app-edit-input-account',
        INPUT_CATEGORY: 'app-edit-input-category',
        INPUT_SUBCATEGORY: 'app-edit-input-subcategory',
        INPUT_ENTORNO: 'app-edit-input-entorno',
        INPUT_TIPO: 'app-edit-input-tipo',
        INPUT_ASSET: 'app-edit-input-asset',
        BTN_SAVE: 'app-edit-btn-save',
        BTN_DELETE: 'app-edit-btn-delete',
        BTN_CLOSE: 'app-edit-btn-close',
        BTN_DELETE_CANCEL: 'app-edit-btn-delete-cancel',
        BTN_DELETE_CONFIRM: 'app-edit-btn-delete-confirm',
        BTN_UNLINK_RELATION: 'app-edit-btn-unlink-relation',
        BTN_KEEP_RELATION: 'app-edit-btn-keep-relation'
    },

    // --- TRANSACTIONS VIEW ---
    TRANSACTIONS: {
        FILTER_BTN: 'app-trans-filter-btn',
        HISTORY_LIMIT_NOTICE: 'app-trans-history-limit-notice',
        HISTORY_LIMIT_CTA: 'app-trans-history-limit-cta',
        TABLE_CONTAINER: 'app-trans-table-container',
        EXPORT_CSV: 'app-trans-export-csv',
        EXPORT_EXCEL: 'app-trans-export-excel',
        EXPORT_PRINT: 'app-trans-export-print',
        FILTERS_CONTAINER: 'app-trans-filters-container',
        ROW_FIRST: 'app-trans-row-first',
        BTN_DELETE_ROW: 'app-trans-btn-delete-row',
        BTN_UNLINK_ROW: 'app-trans-btn-unlink-row',
        IMPORT_CARDS: 'app-tx-import-cards',
        BTN_IMPORT_MOVEMENTS: 'app-trans-btn-import-movements',
        BTN_IMPORT_UPLOAD: 'app-trans-btn-import-upload',
        BTN_IMPORT_SCAN: 'app-trans-btn-import-scan',
        BTN_BULK_EDIT: 'app-trans-btn-bulk-edit',
        BTN_ASSIGN_ASSETS: 'app-trans-btn-assign-assets',
        TOGGLE_SHOW_HIDDEN: 'app-trans-toggle-show-hidden',
    },

    // --- REVIEW HUB VIEW ---
    REVIEW_HUB: {
        CONTAINER: 'app-review-hub-container',
        TAB_BAR: 'app-review-hub-tab-bar',
        TAB_DUBIOUS: 'app-review-hub-tab-dubious',
        TAB_ANOMALIES: 'app-review-hub-tab-anomalies',
        TAB_NO_CATEGORY: 'app-review-hub-tab-no-category',
        SUBTAB_UNCAT_MOVEMENTS: 'app-review-hub-subtab-uncat-movements',
        SUBTAB_UNCAT_BIZUM_TRANSFERS: 'app-review-hub-subtab-uncat-bizum-transfers',
        TAB_RULE_SUGGESTIONS: 'app-review-hub-tab-rule-suggestions',
        TAB_COMPENSATIONS: 'app-review-hub-tab-compensations',
        TAB_ASSET_SUGGESTIONS: 'app-review-hub-tab-asset-suggestions',
        SUBTAB_COMPENSATIONS: 'app-review-hub-subtab-compensations',
        SUBTAB_INTERNAS: 'app-review-hub-subtab-internas',
        BTN_APPROVE_ROW: 'app-review-hub-btn-approve-row',
        FIRST_APPROVE_BTN: 'app-review-hub-first-approve-btn',
        BTN_REJECT_ROW: 'app-review-hub-btn-reject-row',
        BTN_BULK_APPROVE: 'app-review-hub-btn-bulk-approve',
        BTN_BULK_REJECT: 'app-review-hub-btn-bulk-reject',
        BTN_BULK_RECLASSIFY: 'app-review-hub-btn-bulk-reclassify',
        BTN_LINK_ASSET_ROW: 'app-review-hub-btn-link-asset-row',
        ANOMALY_CARD_PREFIX: 'app-review-hub-anomaly-',
        // Compensations (Fase 1)
        BTN_ACCEPT_SUGGESTION: 'app-review-hub-btn-accept-suggestion',
        BTN_CHANGE_PARENT: 'app-review-hub-btn-change-parent',
        BTN_DISMISS_SUGGESTION: 'app-review-hub-btn-dismiss-suggestion',
        BTN_BULK_ACCEPT_HIGH_CONF: 'app-review-hub-btn-bulk-accept-high-conf',
        BTN_UNDO_BULK: 'app-review-hub-btn-undo-bulk',
        COMPENSATION_THRESHOLD_SELECT: 'app-review-hub-compensation-threshold',
        // Banner panorámico (Fase 4)
        OVERVIEW_BANNER: 'app-review-hub-overview-banner',
        BTN_RESOLVE_ALL_AUTO: 'app-review-hub-btn-resolve-all-auto',
        BTN_RECLASSIFY_ALL: 'app-review-hub-btn-reclassify-all',
        GROUP_CHECKBOX: 'app-review-hub-group-checkbox',
        GROUP_CHECKBOX_ALL: 'app-review-hub-group-checkbox-all',
        GROUP_BULK_BAR: 'app-review-hub-group-bulk-bar',
        COUNTERPART_CHECKBOX: 'app-review-hub-counterpart-checkbox',
        COUNTERPART_CHECKBOX_ALL: 'app-review-hub-counterpart-checkbox-all',
        BTN_MERGE_COUNTERPARTS: 'app-review-hub-btn-merge-counterparts',
        BTN_DISMISS_MERGE_SUGGESTION: 'app-review-hub-btn-dismiss-merge-suggestion',
        BTN_ACCEPT_MERGE_SUGGESTION: 'app-review-hub-btn-accept-merge-suggestion',
        BTN_UNMERGE_COUNTERPART: 'app-review-hub-btn-unmerge-counterpart',
        MERGE_MODAL_SELECT_CANONICAL: 'app-review-hub-merge-modal-select-canonical',
        MERGE_MODAL_BTN_CONFIRM: 'app-review-hub-merge-modal-btn-confirm',
        COMPENSATIONS_VIEW_GROUPED: 'app-review-hub-compensations-view-grouped',
        COMPENSATIONS_VIEW_LIST: 'app-review-hub-compensations-view-list',
        BTN_AUTO_COMPENSATE_GROUP: 'app-review-hub-btn-auto-compensate-group',
    },

    // --- PENDING CATEGORIZATION VIEW (Fase 5) ---
    // --- TRIAGE QUEUE (Revisión por lotes, handoff §4) ---
    TRIAGE: {
        CONTAINER: 'app-triage-container',
        PROGRESS: 'app-triage-progress',
        BTN_ACCEPT_ALL: 'app-triage-btn-accept-all',
        RULE_CARD: 'app-triage-rule-card',
        LOTS: 'app-triage-lots',
        DONE: 'app-triage-done',
        SUELTOS: 'app-triage-sueltos',
    },

    PENDING_CATEGORIZATION: {
        CONTAINER: 'app-pending-container',
        BTN_AUTO_CATEGORIZE: 'app-pending-btn-auto-categorize',
        BTN_APPROVE_ALL: 'app-pending-btn-approve-all',
    },

    // --- HUB DE INVERSIONES (InvestmentHub) ---
    INVESTMENT_HUB: {
        TAB_MODE_GENERAL: 'app-hub-mode-general',
        TAB_MODE_PERSONAL: 'app-hub-mode-personal',
        TAB_MODE_BUSINESS: 'app-hub-mode-business',
        ASSETS_CONTAINER: 'app-hub-assets-container',
        BADGE_AT_COST_PREFIX: 'app-hub-badge-at-cost-',
        // F21 (F10.1): rentabilidad ANUALIZADA bajo el badge de plusvalia de cada tarjeta.
        BADGE_CAGR_PREFIX: 'app-hub-badge-cagr-',
        // F8.6: aviso de que la curva "Rendimiento y Crecimiento" es una estimacion, no un historico.
        HINT_GROWTH_ESTIMATED: 'app-hub-hint-growth-estimated',
        // F9.1: recuento de movimientos que se desvincularan al borrar el activo.
        HINT_DELETE_UNLINK: 'app-hub-hint-delete-unlink',
        // F28 (D-H): participacion del usuario cuando la tarjeta muestra solo su parte.
        BADGE_OWNERSHIP_PREFIX: 'app-hub-badge-ownership-'
    },

    // --- PROCESSING REPORT ---
    REPORT: {
        CONTAINER: 'app-report-container',
        BTN_DASHBOARD: 'app-report-btn-dashboard'
    },


    // --- ORGANIZATION (Rules & Goals) ---
    ORGANIZATION: {
        TAB_SMART_RULES: 'app-org-tab-smart-rules',
        TAB_GOALS: 'app-org-tab-goals',
        TAB_REVIEW_ALERTS: 'app-org-tab-review-alerts',
        TAB_BUDGETS: 'app-org-tab-budgets',
        FILTER_ALL: 'app-org-filter-all',
        FILTER_AI: 'app-org-filter-ai',
        FILTER_MANUAL: 'app-org-filter-manual',
        FILTER_INACTIVE: 'app-org-filter-inactive',
        BTN_NEW_RULE: 'app-org-btn-new-rule',
        RULE_CARD_PREFIX: 'app-org-rule-card-',
        BANNER_MORE_CONTROL: 'app-org-banner-control',
        CARD_AI_PREDICTION: 'app-org-card-ai-pred',
        BTN_CONFIGURE_MODEL: 'app-org-btn-config-model',
        BTN_EDIT_RULE: 'app-org-btn-edit-rule',
        BTN_DELETE_RULE: 'app-org-btn-delete-rule',
        BTN_TOGGLE_RULE: 'app-org-btn-toggle-rule',
    },

    // --- HELP VIEW ---
    HELP: {
        CONTAINER: 'app-help-container',
        BTN_CONTACT_SUPPORT: 'app-help-btn-contact',
        LINK_DOCS: 'app-help-link-docs',
        FAQ_ITEM_PREFIX: 'app-help-faq-',
        MODAL_SUPPORT: 'app-help-modal-support',
        MODAL_CATEGORY: 'app-help-support-category',
        MODAL_SUBJECT: 'app-help-support-subject',
        MODAL_MESSAGE: 'app-help-support-message',
        MODAL_BTN_SEND: 'app-help-support-btn-send',
        // F16 — beta cohort opt-in
        BETA_TOGGLE: 'app-help-beta-toggle',
        MODAL_BETA_CONFIRM: 'app-help-beta-confirm-modal',
        BETA_CONFIRM_YES: 'app-help-beta-confirm-yes',
        BETA_CONFIRM_NO: 'app-help-beta-confirm-no',
    },

    // --- FEEDBACK BETA (BetaFeedbackWidget, F16) ---
    BETA_FEEDBACK: {
        FAB: 'app-beta-feedback-fab',
        MODAL: 'app-beta-feedback-modal',
        KIND_PREFIX: 'app-beta-feedback-kind-',
        MESSAGE: 'app-beta-feedback-message',
        BTN_SEND: 'app-beta-feedback-btn-send',
    },

    // --- ESTADÍSTICAS PORTFOLIO (PortfolioDashboard) ---
    PORTFOLIO: {
        COMPARATOR: 'app-portfolio-comparator',
        CONTAINER: 'app-portfolio-container',
        FILTERS_CONTAINER: 'app-portfolio-filters',
        NAV_CONTAINER: 'app-portfolio-nav-container',
        TAB_DASHBOARD: 'app-portfolio-tab-dashboard',
        TAB_ASSETS: 'app-portfolio-tab-assets',
        TAB_INBOX: 'app-portfolio-tab-inbox',
        ASSET_CARD: 'app-portfolio-asset-card',
        BTN_ADD_ASSET_COMP: 'app-portfolio-btn-add-asset-comp',
        BTN_COMP_TAB_PREFIX: 'app-portfolio-comp-tab',
        BTN_EXPORT_CSV_COMP: 'app-portfolio-btn-export-csv-comp',
        // F8.6/F8.8: nota metodologica del Comparador (series estimadas + retorno all-time).
        HINT_COMPARATOR_METHOD: 'app-portfolio-hint-comparator-method',
        BTN_EXPORT_PDF_COMP: 'app-portfolio-btn-export-pdf-comp',
        BTN_UPDATE_BENCHMARKS: 'app-portfolio-btn-update-benchmarks',
        MODAL_ADD_BENCHMARK: 'app-portfolio-add-benchmark-modal'
    },

    // --- ENTITY WIZARD (Wizard de Activos) ---
    ENTITY_WIZARD: {
        INPUT_NAME: 'app-wizard-input-name',
        INPUT_LOCATION: 'app-wizard-input-location',
        INPUT_PRICE: 'app-wizard-input-price',
        TOGGLE_MORTGAGE: 'app-wizard-toggle-mortgage',
        TOGGLE_RENT: 'app-wizard-toggle-rent',

        // Asset Types
        TYPE_PROPERTY: 'app-wizard-type-Property',
        TYPE_VEHICLE: 'app-wizard-type-Vehicle',
        TYPE_COMPANY: 'app-wizard-type-Company',
        TYPE_FUND: 'app-wizard-type-Fund',
        TYPE_STOCK: 'app-wizard-type-Stock',
        TYPE_CRYPTO: 'app-wizard-type-Crypto',
        TYPE_PLAN_AHORRO: 'app-wizard-type-PlanAhorro',
        TYPE_COMMODITY: 'app-wizard-type-Commodity',
        TYPE_OTHER: 'app-wizard-type-Other',

        // Investment Details (step 2 for financial instruments)
        INVESTMENT_INPUT_ISIN: 'app-wizard-investment-isin',
        INVESTMENT_INPUT_FUND_MANAGER: 'app-wizard-investment-fund-manager',
        INVESTMENT_SELECT_SUBTYPE: 'app-wizard-investment-subtype',
        INVESTMENT_INPUT_CONTRIBUTION: 'app-wizard-investment-contribution',
        INVESTMENT_SELECT_FREQUENCY: 'app-wizard-investment-frequency',
        INVESTMENT_INPUT_NUM_UNITS: 'app-wizard-investment-num-units',
        INVESTMENT_INPUT_PRICE_UNIT: 'app-wizard-investment-price-unit',
        INVESTMENT_INPUT_EXCHANGE: 'app-wizard-investment-exchange',
        INVESTMENT_INPUT_BLOCKCHAIN: 'app-wizard-investment-blockchain',
        INVESTMENT_SELECT_COMMODITY: 'app-wizard-investment-commodity-type',
        INVESTMENT_INPUT_RESCUE_DATE: 'app-wizard-investment-rescue-date',
        INVESTMENT_INPUT_EXPECTED_RETURN: 'app-wizard-investment-expected-return',

        // Mortgage
        MORTGAGE_INPUT_APPRAISAL: 'app-wizard-mortgage-appraisal',
        MORTGAGE_SLIDER_EQUITY: 'app-wizard-mortgage-equity-slider',
        MORTGAGE_SELECT_TYPE: 'app-wizard-mortgage-type',
        MORTGAGE_INPUT_TERM: 'app-wizard-mortgage-term',
        MORTGAGE_INPUT_TERM_FIXED: 'app-wizard-mortgage-term-fixed',
        MORTGAGE_INPUT_START: 'app-wizard-mortgage-start',
        MORTGAGE_INPUT_INTEREST_FIXED: 'app-wizard-mortgage-interest-fixed',
        MORTGAGE_INPUT_INTEREST_VAR: 'app-wizard-mortgage-interest-var',
        MORTGAGE_INPUT_BONUS: 'app-wizard-mortgage-bonus',
        MORTGAGE_INPUT_EXPENSES: 'app-wizard-mortgage-expenses',
        LEASE_INPUT_START_DATE: 'app-wizard-lease-start-date',
        TOGGLE_RENOVATION: 'app-wizard-toggle-renovation',
        INPUT_RENOVATION_COST: 'app-wizard-input-renovation-cost',
        // AUDIT_ACTIVOS F6.1: inputs fiscales del motor Renta 2026 (val_muebles / pct_const).
        INPUT_FURNITURE_VALUE: 'app-wizard-input-furniture-value',
        INPUT_CONSTRUCTION_PCT: 'app-wizard-input-construction-pct',

        // Rental
        RENTAL_TYPE_PREFIX: 'app-wizard-rental-type-',
        RENTAL_INPUT_INCOME: 'app-wizard-rental-income',
        RENTAL_INPUT_START_DATE: 'app-wizard-rental-start-date',
        RENTAL_BTN_ADD_ROOM: 'app-wizard-rental-add-room',
        // AUDIT_ACTIVOS F6.1: superficie por habitación (prorrateo espacio-temporal Renta 2026).
        RENTAL_INPUT_ROOM_M2: 'app-wizard-rental-room-m2',


        BTN_UPLOAD_MAIN_CONTRACT: 'app-wizard-btn-upload-contract',
        BTN_UPLOAD_ROOM_CONTRACTS: 'app-wizard-btn-upload-rooms',

        INPUT_ASSET_CONTEXT: 'app-entity-wizard-input-asset-context',
        INPUT_OWNERSHIP_PERCENT: 'app-entity-wizard-input-ownership-percent',
        INPUT_IDEALISTA_URL: 'app-entity-wizard-input-idealista-url',
        CHECKBOX_FIRST_HOME: 'app-entity-wizard-checkbox-first-home',
        CHECKBOX_YOUNG_BUYER: 'app-entity-wizard-checkbox-young-buyer',
        CHECKBOX_HABITUAL_RESIDENCE: 'app-entity-wizard-checkbox-habitual-residence',
        SELECT_KINSHIP_GROUP: 'app-entity-wizard-select-kinship-group',

        BTN_NEXT: 'app-wizard-btn-next',
        BTN_BACK: 'app-wizard-btn-back',
        BTN_CANCEL: 'app-wizard-btn-cancel',
        BTN_SAVE: 'app-wizard-btn-save',
    },

    // --- ENTITY DASHBOARD (Detalle Activo) ---
    ENTITY_DASHBOARD: {
        HEADER_TITLE: 'app-entity-title',
        BTN_BACK: 'app-entity-btn-back',
        // F7.4 — nivel 3. Los antiguos TAB_OVERVIEW/TAB_SUMMARY desaparecen: la «Vista General»
        // se reparte entre las secciones de nivel 2 y la ficha, y el «Resumen» duplicaba datos.
        TAB_FINANCIALS: 'app-entity-tab-financials',
        TAB_DETAILS: 'app-entity-tab-details',
        TAB_SIMULATOR: 'app-entity-tab-simulator',

        // F7.2 — nivel 1: los 4 KPIs primarios aprobados en D-E.
        KPI_MONTHLY_CASHFLOW: 'app-entity-kpi-monthly-cashflow',
        KPI_ROI: 'app-entity-kpi-roi',
        KPI_INITIAL_EQUITY: 'app-entity-kpi-initial-equity',
        KPI_PER: 'app-entity-kpi-per',
        KPI_CURRENT_VALUE: 'app-entity-kpi-current-value',
        // F30 (F10.5 parcial): valoracion de mercado SUGERIDA (numUnits x ultimo cierre) para los
        // simbolos comprables que la app ya descarga, con su accion de aplicar.
        HINT_MARKET_VALUE: 'app-entity-hint-market-value',
        BTN_APPLY_MARKET_VALUE: 'app-entity-btn-apply-market-value',
        BADGE_AT_COST: 'app-entity-badge-at-cost',
        // F11 (R4): el valor bruto sale de las aportaciones, no de una valoracion de mercado.
        BADGE_VALUE_FROM_CONTRIBUTIONS: 'app-entity-badge-value-from-contributions',
        // F28 (D-H): participacion del usuario y su parte del valor neto (la ficha va al 100 %).
        BADGE_OWNERSHIP_SHARE: 'app-entity-badge-ownership-share',
        // F11 (R6): «antes de impuestos» bajo el beneficio neto mensual y anual (uno por cifra:
        // dos elementos no pueden compartir id en el DOM).
        HINT_PRE_TAX_MONTHLY: 'app-entity-hint-pre-tax-monthly',
        HINT_CAPITAL_ONLY: 'app-entity-hint-capital-only',
        KPI_WITHDRAWN_CAPITAL: 'app-entity-kpi-withdrawn-capital',
        HINT_PRE_TAX_ANNUAL: 'app-entity-hint-pre-tax-annual',
        // C1-a: contributed capital + inline manual currentValue editor (Fund/Stock/Crypto)
        KPI_CONTRIBUTED_CAPITAL: 'app-entity-kpi-contributed-capital',
        KPI_DERIVED_DIFFERENCE: 'app-entity-kpi-derived-difference',
        BTN_EDIT_CURRENT_VALUE: 'app-entity-btn-edit-current-value',
        INPUT_CURRENT_VALUE: 'app-entity-input-current-value',
        BTN_SAVE_CURRENT_VALUE: 'app-entity-btn-save-current-value',
        BTN_CANCEL_CURRENT_VALUE: 'app-entity-btn-cancel-current-value',
        KPI_DEBT: 'app-entity-kpi-debt',
        // F3 (D-C): aviso de divergencia entre el saldo anclado a mano y las cuotas registradas.
        HINT_DEBT_DIVERGENCE: 'app-entity-hint-debt-divergence',
        // F7.2: LTV (deuda ÷ valor bruto) como subtexto del KPI de deuda.
        HINT_LTV: 'app-entity-hint-ltv',
        // F21 (F10.2): DSCR (ingreso operativo neto anual ÷ servicio anual de la deuda), junto al LTV.
        HINT_DSCR: 'app-entity-hint-dscr',
        // F21 (F10.1): rentabilidad total ANUALIZADA (CAGR) — fila en «Rentabilidad» y subtexto del
        // ROI en el bloque financiero.
        KPI_CAGR: 'app-entity-kpi-cagr',
        HINT_CAGR: 'app-entity-hint-cagr',
        KPI_NET_MONTHLY_INCOME: 'app-entity-kpi-net-monthly',
        KPI_NET_ANNUAL_INCOME: 'app-entity-kpi-net-annual',
        KPI_ROE: 'app-entity-kpi-roe',
        KPI_ROE_NET: 'app-entity-kpi-roe-net',
        KPI_PER_NET: 'app-entity-kpi-per-net',
        // F4 (D-A/D-B): plusvalía apalancada (antes "ROI") y ROE real sobre el equity actual.
        KPI_CAPITAL_GAIN_EQUITY: 'app-entity-kpi-capital-gain-equity',
        KPI_REAL_ROE: 'app-entity-kpi-real-roe',
        // F4.5: capital propio ya recuperado con los movimientos reales vinculados.
        HINT_CAPITAL_RECOVERED: 'app-entity-hint-capital-recovered',
        // F5.3: acumulados de los movimientos vinculados — caja (cuota íntegra) y beneficio (D1).
        KPI_ACCUMULATED_INCOME: 'app-entity-kpi-accumulated-income',
        KPI_ACCUMULATED_EXPENSES: 'app-entity-kpi-accumulated-expenses',
        KPI_NET_CASHFLOW: 'app-entity-kpi-net-cashflow',
        KPI_NET_PROFIT: 'app-entity-kpi-net-profit',
        // F6.5: supuestos activos del bloque Renta 2026 (ocupación, pct_const, marginal IRPF).
        HINT_RE_ASSUMPTIONS: 'app-entity-hint-re-assumptions',
        // F7.4: banner de proyección teórica que encabeza el tab del Simulador.
        BANNER_SIMULATOR: 'app-entity-banner-simulator',
        // F27 (F10.8): IRPF del arrendamiento, solo cuando hay un marginal REAL derivado de la
        // declaración; el neto antes y después de impuestos se pintan uno al lado del otro.
        KPI_RE_NET_BEFORE_TAX: 'app-entity-kpi-re-net-before-tax',
        KPI_RE_IRPF: 'app-entity-kpi-re-irpf',
        KPI_RE_NET_AFTER_TAX: 'app-entity-kpi-re-net-after-tax',

        // F7.3 — nivel 2: secciones semánticas y sus cifras.
        SECTION_EQUITY: 'app-entity-section-equity',
        SECTION_RETURNS: 'app-entity-section-returns',
        SECTION_CASHFLOW: 'app-entity-section-cashflow',
        KPI_PURCHASE_VALUE: 'app-entity-kpi-purchase-value',
        KPI_TOTAL_COST: 'app-entity-kpi-total-cost',
        KPI_NET_DIFFERENTIAL: 'app-entity-kpi-net-differential',
        KPI_GROSS_YIELD: 'app-entity-kpi-gross-yield',
        KPI_ROSE: 'app-entity-kpi-rose',
        KPI_ANNUAL_CASHFLOW: 'app-entity-kpi-annual-cashflow',
        // F19: the monthly loan instalment was an input to every projection but was
        // displayed nowhere in the asset sheet.
        KPI_LOAN_PAYMENT: 'app-entity-kpi-loan-payment',
        // F21 (F10.3): ocupacion minima con cash flow >= 0, bajo la cuota que es su mayor sumando.
        KPI_BREAKEVEN_OCCUPANCY: 'app-entity-kpi-breakeven-occupancy',
        HINT_BREAKEVEN_ABOVE_100: 'app-entity-hint-breakeven-above-100',
        // F24 (F10.6): TIR del inversor con los flujos fechados reales + valor terminal de hoy.
        KPI_XIRR: 'app-entity-kpi-xirr',
        HINT_XIRR: 'app-entity-hint-xirr',
        // F25 (F10.7): TWR sobre el historico de valoraciones + la curva que ese historico dibuja.
        KPI_TWR: 'app-entity-kpi-twr',
        HINT_TWR: 'app-entity-hint-twr',
        SECTION_VALUATION_HISTORY: 'app-entity-section-valuation-history',
        CHART_VALUATION_HISTORY: 'app-entity-chart-valuation-history',
        // F23 (F10.4): renta configurada vs cobros reales — «cobrado X % de lo previsto».
        KPI_RENT_COLLECTED_PCT: 'app-entity-kpi-rent-collected-pct',
        HINT_RENT_COLLECTED_WINDOW: 'app-entity-hint-rent-collected-window',
        // F8.7: bloque propio de activos de uso (Vehiculo/Otro) — depreciacion declarada.
        KPI_DEPRECIATION: 'app-entity-kpi-depreciation',
        // F21 (F10.9): reparto ANUAL de esa depreciacion + recordatorio de revalorizacion.
        HINT_DEPRECIATION_ANNUAL: 'app-entity-hint-depreciation-annual',
        HINT_REVALUATION_REMINDER: 'app-entity-hint-revaluation-reminder',
        CHART_MORTGAGE: 'app-entity-chart-mortgage',
        BTN_SYNC_IDEALISTA: 'app-entity-btn-sync-idealista',

        ACTION_EDIT: 'app-entity-action-edit',
        ACTION_DELETE: 'app-entity-action-delete',
        ACTION_EXPENSE: 'app-entity-action-expense',
        ACTION_IDEALISTA: 'app-entity-action-idealista',
        ACTION_LINK_ASSETS: 'app-entity-action-link-assets',
        // F7.5: menú «⋯» de la barra de acciones (Editar / Eliminar).
        ACTION_MORE: 'app-entity-action-more',

        MODAL_IDEALISTA: 'app-entity-modal-idealista',

    },

    // --- SUBSCRIPTION ---
    SUBSCRIPTION: {
        TAB_PLAN: 'app-settings-tab-plan',
        PLAN_SUMMARY: 'app-subscription-plan-summary',
        BTN_UPGRADE: 'app-subscription-btn-upgrade',
        BTN_MANAGE: 'app-subscription-btn-manage',
        BADGE_PRO: 'badge-subscription-pro',
        BADGE_ADMIN: 'badge-subscription-admin',
        MODAL_UPGRADE: 'app-subscription-modal-upgrade',
        MODAL_BTN_CHECKOUT: 'app-subscription-modal-btn-checkout',
        MODAL_CHECKOUT_CONSENT: 'app-subscription-modal-checkout-consent',
        CHECKOUT_CONSENT_CHECKBOX: 'app-subscription-checkout-consent-chk',
        CHECKOUT_CONSENT_CONFIRM: 'app-subscription-checkout-consent-confirm',
        BTN_WITHDRAW: 'app-subscription-btn-withdraw',
        MODAL_WITHDRAWAL: 'app-subscription-modal-withdrawal',
        WITHDRAWAL_MSG: 'app-subscription-withdrawal-msg',
        WITHDRAWAL_SUBMIT: 'app-subscription-withdrawal-submit',
        PLAN_FREE_CARD: 'app-subscription-plan-free',
        PLAN_PRO_CARD: 'app-subscription-plan-pro',
        BTN_BILLING_MONTHLY: 'app-subscription-btn-billing-monthly',
        BTN_BILLING_ANNUAL: 'app-subscription-btn-billing-annual',
        DUNNING_BANNER: 'app-subscription-dunning-banner',
        DUNNING_CTA: 'app-subscription-dunning-cta',
    },

    // --- PLANS (canonical pricing view) ---
    PLANS: {
        CONTAINER: 'app-plans-container',
        BILLING_TOGGLE: 'app-plans-billing-toggle',
        CARD_DIAMOND: 'app-subscription-plan-diamond',
        COMPARE_TABLE: 'app-plans-compare-table',
        TRUST_BAND: 'app-plans-trust-band',
        FAQ: 'app-plans-faq',
        FOUNDING_BANNER: 'app-plans-founding-banner',
        FOUNDING_CTA_MONTHLY: 'app-plans-founding-cta-monthly',
        FOUNDING_CTA_ANNUAL: 'app-plans-founding-cta-annual',
        // F22 — seasonal one-off "Campaña Renta"
        RENTA_BANNER: 'app-plans-renta-banner',
        RENTA_CTA: 'app-plans-renta-cta',
        RENTA_CONSENT_MODAL: 'app-plans-renta-consent-modal',
        RENTA_CONSENT_CHECKBOX: 'app-plans-renta-consent-checkbox',
        RENTA_CONSENT_CONFIRM: 'app-plans-renta-consent-confirm',
    },

    // --- LEGAL ---
    LEGAL: {
        CONSENT_BTN_ACCEPT: 'app-legal-consent-btn-accept',
        CONSENT_BTN_DECLINE: 'app-legal-consent-btn-decline',
        CONSENT_LINK_FULL: 'app-legal-consent-link-full',
        PAGE_TAB_NOTICE: 'app-legal-page-tab-notice',
        PAGE_TAB_PRIVACY: 'app-legal-page-tab-privacy',
        PAGE_TAB_TERMS: 'app-legal-page-tab-terms',
        PAGE_TAB_COOKIES: 'app-legal-page-tab-cookies',
        SIDEBAR_LINK: 'app-legal-sidebar-link',
    },

    // --- ACCOUNT DETAIL ---
    ACCOUNT_DETAIL: {
        BACK_BTN: 'app-account-detail-back-btn',
        BTN_REVIEW_EXCLUDED: 'app-account-detail-review-excluded',
        BTN_RESTORE_EXCLUDED: 'app-account-detail-restore-excluded',
    },

    // --- ESCÁNER INTELIGENTE ---
    SCANNER: {
        MODAL: 'app-scanner-modal',
        DROPZONE: 'app-scanner-dropzone',
        BTN_CAMERA: 'app-scanner-btn-camera',
        BTN_CLOSE: 'app-scanner-btn-close',
        LOADING_SPINNER: 'app-scanner-loading',
        SELECT_ACCOUNT: 'app-scanner-select-account'
    },

    // --- CÁMARA (CameraModal) ---
    CAMERA: {
        MODAL: 'app-camera-modal',
        BTN_CLOSE: 'app-camera-btn-close',
        BTN_CAPTURE: 'app-camera-btn-capture',
        BTN_ANALYZE: 'app-camera-btn-analyze',
        THUMBNAIL_PREFIX: 'app-camera-thumbnail-'
    },

    // --- PRESUPUESTOS (F5 — R9) ---
    BUDGETS: {
        CONTAINER: 'app-budgets-container',
        BTN_NEW: 'app-budgets-btn-new',
        LIST: 'app-budgets-list',
        ROW_PREFIX: 'app-budgets-row-',
        BTN_EDIT_PREFIX: 'app-budgets-btn-edit-',
        BTN_DELETE_PREFIX: 'app-budgets-btn-delete-',
        FORM_CATEGORY: 'app-budgets-form-category',
        FORM_SUBCATEGORY: 'app-budgets-form-subcategory',
        FORM_LIMIT: 'app-budgets-form-limit',
        FORM_ENTORNO: 'app-budgets-form-entorno',
        BTN_SAVE: 'app-budgets-btn-save',
    },

    // --- REGLAS Y METAS (Rules & Goals) ---
    RULES_GOALS: {
        CONTAINER: 'app-rules-goals-container',
        CARD_AI_INSIGHTS: 'app-goals-card-ai',
        BTN_SHARE_GOAL: 'app-goals-btn-share',
        BTN_GOAL_ANALYSIS: 'app-goals-btn-analysis',
    },

    // --- MODAL ---
    MODAL: {
        RATE_LIMIT: {
            CONTAINER: 'app-modal-rate-limit',
            BTN_CLOSE: 'app-modal-rate-limit-btn-close',
            OPT_WAIT: 'app-modal-rate-limit-opt-wait',
            OPT_BYOK: 'app-modal-rate-limit-opt-byok',
            OPT_PRO: 'app-modal-rate-limit-opt-pro'
        }
    },
    // --- AUTH (Login / Registro) ---
    AUTH: {
        LEFT_PANE: 'app-auth-left-pane',
        LOGO_ANIMATED: 'app-auth-logo-animated',
        LOGIN_EMAIL: 'app-auth-login-email',
        LOGIN_PASSWORD: 'app-auth-login-password',
        BTN_GOOGLE_LOGIN: 'app-auth-btn-google-login',
        REGISTER_NAME: 'app-auth-register-name',
        REGISTER_EMAIL: 'app-auth-register-email',
        REGISTER_PHONE: 'app-auth-register-phone',
        REGISTER_PASSWORD: 'app-auth-register-password',
        REGISTER_CONFIRM: 'app-auth-register-confirm',
        REGISTER_TERMS: 'app-auth-register-terms',
        FORGOT_EMAIL: 'app-auth-forgot-email',
        BTN_FORGOT_REQUEST: 'app-auth-btn-forgot-request',
        BTN_FORGOT_CANCEL: 'app-auth-btn-forgot-cancel',
        RESET_CODE: 'app-auth-reset-code',
        RESET_PASSWORD: 'app-auth-reset-password'
    },

    // --- CATEGORIZATION PANEL ---
    CATEGORIZATION_PANEL: {
        BULK_TOOLBAR: 'app-cat-bulk-toolbar',
        BULK_SELECT_ENTORNO: 'app-cat-bulk-entorno',
        BULK_SELECT_TIPO: 'app-cat-bulk-tipo',
        BULK_SELECT_CATEGORY: 'app-cat-bulk-category',
        BULK_SELECT_SUBCATEGORY: 'app-cat-bulk-subcategory',
        BULK_APPLY_BTN: 'app-cat-bulk-apply',
        BTN_BACK: 'app-cat-btn-back',
        BTN_LINK_ASSETS: 'app-cat-btn-link-assets',
        BTN_APPROVE_SELECTED: 'app-cat-btn-approve-selected',
        BTN_AI_CATEGORIZE: 'app-cat-btn-ai-categorize',
        BTN_FILTER_TOGGLE: 'app-cat-btn-filter-toggle',
        BTN_MARK_RELATION: 'app-cat-btn-mark-relation',
        BTN_DELETE_SELECTED: 'app-cat-btn-delete-selected',
        BTN_LINK_ACCOUNT_BULK: 'app-cat-btn-link-account-bulk',
        BTN_LINK_ASSETS_BULK: 'app-cat-btn-link-assets-bulk',
        MOVEMENTS_COUNT: 'app-cat-movements-count',
    },

    // --- CATEGORIZATION FILTERS BAR ---
    CATEGORIZATION_FILTERS: {
        CONTAINER: 'app-cat-filters-bar',
        CHIP_DATE: 'app-cat-filter-chip-date',
        CHIP_AMOUNT: 'app-cat-filter-chip-amount',
        CHIP_FLOW: 'app-cat-filter-chip-flow',
        CHIP_SEARCH: 'app-cat-filter-chip-search',
        CHIP_STATUS: 'app-cat-filter-chip-status',
        CHIP_ASSET: 'app-cat-filter-chip-asset',
        CHIP_ENTORNO: 'app-cat-filter-chip-entorno',
        CHIP_TIPO: 'app-cat-filter-chip-tipo',
        CHIP_CATEGORY: 'app-cat-filter-chip-category',
        CHIP_SUBCATEGORY: 'app-cat-filter-chip-subcategory',
        CHIP_ACCOUNT: 'app-cat-filter-chip-account',
        BTN_CLEAR_ALL: 'app-cat-filter-clear-all',
        POPOVER_PREFIX: 'app-cat-filter-popover-',
    },

    // --- SMART CATEGORIZATION ---
    SMART_CAT: {
        DIALOG_CONTAINER: 'app-smart-cat-dialog',
        DIALOG_CLOSE: 'app-smart-cat-dialog-close',
        BTN_RUN_ANALYSIS: 'app-smart-cat-btn-run',
        PREDICTION_CARD_PREFIX: 'app-smart-cat-pred-card-',
        BTN_CONFIRM_PREFIX: 'app-smart-cat-btn-confirm-',
        BTN_REJECT_PREFIX: 'app-smart-cat-btn-reject-',
    },
    // --- FEATURE CONSENT MODAL ---
    FEATURE_CONSENT: {
        BTN_ACCEPT: 'app-consent-btn-accept',
        BTN_CANCEL: 'app-consent-btn-cancel',
        CHECK_SERVICE: 'app-consent-check-service',
        CHECK_TRAINING: 'app-consent-check-training',
    },
    // --- REVISIÓN DE RECIBOS ---
    RECEIPT_REVIEW: {
        MODAL: 'app-receipt-review-modal',
        BTN_CLOSE: 'app-receipt-review-btn-close',
        BTN_SAVE: 'app-receipt-review-btn-save',
        BTN_CANCEL: 'app-receipt-review-btn-cancel',
        ITEM_CARD: 'app-receipt-review-item',
        INPUT_DESC: 'app-receipt-review-input-desc',
        INPUT_AMOUNT: 'app-receipt-review-input-amount',
        INPUT_DATE: 'app-receipt-review-input-date',
        SELECT_ACCOUNT: 'app-receipt-review-select-account',
        BTN_DELETE_ITEM: 'app-receipt-review-btn-delete-item'
    },


    // --- TOOLS VIEW (Herramientas) ---
    TOOLS_VIEW: {
        CONTAINER:      'app-tools-view-container',
        SUBNAV:         'app-tools-subnav',
        SUBNAV_REPORTS: 'app-tools-subnav-reports',
        SUBNAV_TAX:     'app-tools-subnav-tax-sim',
        SUBNAV_FREELANCE_TAX: 'app-tools-subnav-freelance-tax',
        SUBNAV_FIRE:    'app-tools-subnav-fire-calc',
        SUBNAV_SPENDING_OPTIMIZER: 'app-tools-subnav-spending-optimizer',
        SUBNAV_REAL_ESTATE: 'app-tools-subnav-real-estate',
        SUBNAV_INVOICES: 'app-tools-subnav-invoices',
        CONTENT:        'app-tools-content',
        // Interactive IDs for tools
        FIRE_INITIAL_CAPITAL: 'app-tools-fire-initial-capital',
        FIRE_MONTHLY_CONTRIBUTION: 'app-tools-fire-monthly-contribution',
        FIRE_EXPECTED_YIELD: 'app-tools-fire-expected-yield',
        FIRE_ANNUAL_EXPENSES: 'app-tools-fire-annual-expenses',
        FIRE_SWR: 'app-tools-fire-swr',
        FIRE_USE_REAL_DATA: 'app-tools-fire-use-real-data',
        FIRE_USE_REAL_SAVINGS: 'app-tools-fire-use-real-savings',
        FREELANCE_DEDUCTIBLE_PERCENT: 'app-tools-freelance-deductible-percent',
        FREELANCE_PERIOD_YEAR: 'app-tools-freelance-period-year',
        FREELANCE_PERIOD_QUARTER: 'app-tools-freelance-period-quarter',
        FREELANCE_303_LOCK: 'app-tools-freelance-303-lock',
        FREELANCE_130_LOCK: 'app-tools-freelance-130-lock',
        SPENDING_OPTIMIZER_CONTAINER: 'app-tools-spending-optimizer-container',
        SPENDING_OPTIMIZER_LOCKED_SUBS: 'app-tools-spending-optimizer-locked-subs',
        SPENDING_OPTIMIZER_LOCKED_INSIGHTS: 'app-tools-spending-optimizer-locked-insights',
    },
    // --- LANDING PAGE ---
    LANDING: {
        PAGE_ROOT: 'app-landing-root',
        HERO_TITLE: 'app-landing-hero-title',
        CTA_INSTALL: 'app-landing-cta-install',
        CTA_LOGIN: 'app-landing-cta-login',
        BTN_FREE: 'app-landing-btn-free',
        BTN_PRO_MONTHLY: 'app-landing-btn-pro-monthly',
        BTN_PRO_ANNUAL: 'app-landing-btn-pro-annual',
        SIM_SALARY_SLIDER: 'app-landing-sim-salary-slider',
        SIM_OPTIMIZE_SWITCH: 'app-landing-sim-optimize-switch',
        SIM_REGION_SELECT: 'app-landing-sim-region-select',
        SIM_RESULT_CARD: 'app-landing-sim-result-card',
        BTN_FISCAL: 'app-landing-btn-fiscal',
        CTA_START_HERO: 'app-landing-cta-start-hero',
        CTA_DEMO: 'app-landing-cta-demo',
        CTA_INSTALL_FOOTER: 'app-landing-cta-install-footer',
        SELFEMPLOYED_CTA_START: 'app-landing-selfemployed-cta-start',
        SELFEMPLOYED_CTA_DEMO: 'app-landing-selfemployed-cta-demo',
        SCROLL_INDICATOR: 'app-landing-scroll-indicator',
        BACK_TO_TOP: 'app-landing-back-to-top',
        FOOTER_LEGAL: 'app-landing-footer-legal',
        FOOTER_PRIVACY: 'app-landing-footer-privacy',
        FOOTER_TERMS: 'app-landing-footer-terms',
        LEGAL_OVERLAY: 'app-landing-legal-overlay',
        TOGGLE_BILLING_ANNUAL: 'app-landing-toggle-billing-annual',
        FOUNDING_BANNER: 'app-landing-founding-banner',
        FOUNDING_CTA_MONTHLY: 'app-landing-founding-cta-monthly',
        FOUNDING_CTA_ANNUAL: 'app-landing-founding-cta-annual',
        // F22 — seasonal one-off "Campaña Renta"
        RENTA_SECTION: 'app-landing-renta-section',
        RENTA_CTA: 'app-landing-renta-cta',
    },
    // --- ASSET MATCHING VIEW ---
    ASSET_MATCHING: {
        SEARCH_INPUT: 'app-asset-matching-search',
        FILTER_TYPE: 'app-asset-matching-filter-type',
        FILTER_ASSET: 'app-asset-matching-filter-asset',
        FILTER_CONTEXT: 'app-asset-matching-filter-context',
        FILTER_ACCOUNT: 'app-asset-matching-filter-account',
        FILTER_CATEGORY: 'app-asset-matching-filter-category',
        FILTER_SUBCATEGORY: 'app-asset-matching-filter-subcategory',
        INPUT_DATE_FROM: 'app-asset-matching-date-from',
        INPUT_DATE_TO: 'app-asset-matching-date-to',
        INPUT_MIN_AMOUNT: 'app-asset-matching-min-amount',
        INPUT_MAX_AMOUNT: 'app-asset-matching-max-amount',
        SORT_BY: 'app-asset-matching-sort-by',
        SORT_ORDER: 'app-asset-matching-sort-order',
        TARGET_ASSET: 'app-asset-matching-target-asset',
        BTN_ASSIGN: 'app-asset-matching-btn-assign',
        BTN_UNLINK: 'app-asset-matching-btn-unlink',
        CHECKBOX_SELECT_ALL: 'app-asset-matching-select-all',
        CHECKBOX_SELECT_ROW_PREFIX: 'app-asset-matching-select-row-',
        BTN_TOGGLE_ADVANCED: 'app-asset-matching-btn-toggle-advanced',
        BTN_CLEAR_FILTERS: 'app-asset-matching-btn-clear-filters',
    },
    COMPENSATE_MODAL: {
        CONTAINER: 'app-compensate-modal-container',
        BTN_CLOSE: 'app-compensate-modal-btn-close',
        BTN_CONFIRM: 'app-compensate-modal-btn-confirm',
        BTN_ADD_ROW: 'app-compensate-modal-btn-add-row',
        BTN_DELETE_ROW: 'app-compensate-modal-btn-delete-row',
        INPUT_PERCENT: 'app-compensate-modal-input-percent',
        SELECT_ENTORNO: 'app-compensate-modal-select-entorno',
        SELECT_TIPO: 'app-compensate-modal-select-tipo',
        SELECT_CATEGORY: 'app-compensate-modal-select-category',
        SELECT_SUBCATEGORY: 'app-compensate-modal-select-subcategory',
        BTN_COMPENSAR: 'app-compensate-btn',
    },

    // --- REAL ESTATE SIMULATOR (Simulador Inmobiliario, Tier 3) ---
    REAL_ESTATE_SIMULATOR: {
        VIEW:           'app-real-estate-view',
        HEADER:         'app-real-estate-header',
        SCENARIO_BAR:   'app-real-estate-scenario-bar',
        SCENARIO_NAME:  'app-real-estate-scenario-name',
        ALERTS:         'app-real-estate-alerts',
        FORM:           'app-real-estate-form',
        MODEL:          'app-real-estate-model',
        VPO_FLAG:       'app-real-estate-vpo-flag',
        PURCHASE_PRICE: 'app-real-estate-purchase-price',
        MORTGAGE_TOGGLE:'app-real-estate-mortgage-toggle',
        ROOMS:          'app-real-estate-rooms',
        ADD_ROOM:       'app-real-estate-add-room',
        RESULTS:        'app-real-estate-results',
        COMPARATOR:     'app-real-estate-comparator',
        R2R:            'app-real-estate-r2r',
        PROJECTION:     'app-real-estate-projection',
        LOCKED_CONTAINER: 'app-real-estate-locked-container',
        LOCKED_CTA:     'app-real-estate-locked-cta',
    },

    // --- FISCAL (disclaimer legal compartido) ---
    FISCAL: {
        DISCLAIMER: 'app-fiscal-disclaimer',
    },

    // --- STANDALONE SEO CALCULATORS (F15a — pages outside the SPA shell) ---
    CALCULATORS: {
        IRPF_2025_ROOT: 'calc-irpf-2025-root',
        IRPF_2025_SALARY_INPUT: 'calc-irpf-2025-salary-input',
        IRPF_2025_SALARY_SLIDER: 'calc-irpf-2025-salary-slider',
        IRPF_2025_REGION_SELECT: 'calc-irpf-2025-region-select',
        IRPF_2025_RESULT_CARD: 'calc-irpf-2025-result-card',
        IRPF_2025_DISCLAIMER: 'calc-irpf-2025-disclaimer',
        IRPF_2025_CTA_APP: 'calc-irpf-2025-cta-app',
        // F15b — catalog pages (15 CCAA + modelo 130 + modelo 303 + plan de pensiones)
        IRPF_2025_HIGHLIGHTS_CARD: 'calc-irpf-2025-highlights-card',
        RELATED_LINKS: 'calc-related-links',
        CCAA_LINKS: 'calc-ccaa-links',
        M130_ROOT: 'calc-modelo-130-root',
        M130_INCOME_INPUT: 'calc-modelo-130-income-input',
        M130_EXPENSES_INPUT: 'calc-modelo-130-expenses-input',
        M130_RESULT_CARD: 'calc-modelo-130-result-card',
        M130_DISCLAIMER: 'calc-modelo-130-disclaimer',
        M130_CTA_APP: 'calc-modelo-130-cta-app',
        M303_ROOT: 'calc-modelo-303-root',
        M303_INCOME_INPUT: 'calc-modelo-303-income-input',
        M303_INCOME_RATE_SELECT: 'calc-modelo-303-income-rate-select',
        M303_EXPENSES_INPUT: 'calc-modelo-303-expenses-input',
        M303_EXPENSE_RATE_SELECT: 'calc-modelo-303-expense-rate-select',
        M303_RESULT_CARD: 'calc-modelo-303-result-card',
        M303_DISCLAIMER: 'calc-modelo-303-disclaimer',
        M303_CTA_APP: 'calc-modelo-303-cta-app',
        PENSION_ROOT: 'calc-pension-root',
        PENSION_SALARY_INPUT: 'calc-pension-salary-input',
        PENSION_REGION_SELECT: 'calc-pension-region-select',
        PENSION_RESULT_CARD: 'calc-pension-result-card',
        PENSION_DISCLAIMER: 'calc-pension-disclaimer',
        PENSION_CTA_APP: 'calc-pension-cta-app',
    },
};


